export let CONFIGURATION = {
    baseUrls: {
        authenticationUrl: 'https://services.affinitiv.com/connectiv1.ms.admt.auth/API/admt/oauth2/token',
        authenticationBody: 'username=%%username%%&password=%%password%%&grant_type=password&client_id=099153c2625149bc8ecb3e85e03f0022',
        refreshTokenBody: 'refresh_token=%%refreshtoken%%&grant_type=refresh_token&client_id=099153c2625149bc8ecb3e85e03f0022',
        apiUrl: 'api/',
        AuthBaseURL: 'https://services.affinitiv.com/connectiv1.ms.admt.auth/API/api/',
        ADMTServiceURL: 'https://services.affinitiv.com/connectiv1.ms.admt/api/api/',
        UserURL: 'https://services.affinitiv.com/connectiv1.ms.admt.auth/API/api/',
        ReportBaseURL: 'https://services.affinitiv.com/connectiv.ms.reports/api/api/',
        CustomerBaseURL: 'https://services.affinitiv.com/connectiv.ms.customer/api/api/',
    },
    constants: {
        reportsSessionKey: "reportsSession",
        CookieName: '_authcookie',
        CookieExpiryTime: 1440, //time in mins
        CookieDomain: 'localhost',
        CookieStoragepath: '',
        listfileUploadUrl: 'https://s3.amazonaws.com/c1-data-lake/',
        ListBucketPath: 'KIA_Active_dealers/'
    }
}